export default {
	// th-TH.js
	security: {
		securityBind: "ผูกความปลอดภัย",
		securitySettings: "การตั้งค่าความปลอดภัย",
		level: "ปานกลาง",
		confirm: "ยืนยัน",
		submitting: "กำลังส่ง...",
		add: "เพิ่ม",
		change: "เปลี่ยน",
		success: "อัปเดตสำเร็จ",
		select: "เลือก",

		birthday: "วันเกิดผู้ติดต่อ",
		birthdayDesc: "ผูกวันเกิดผู้ติดต่อเพื่อให้สื่อสารได้ง่ายขึ้น ข้อมูลส่วนตัวของคุณจะได้รับการปกป้อง",
		month: "เดือน",
		day: "วัน",
		year: "ปี",
		birthdayRequired: "จำเป็นต้องกรอกวันเกิด",
		invalidBirthday: "วันเกิดไม่ถูกต้อง",
		invalidMonth: "เดือนไม่ถูกต้อง",
		invalidDay: "วันไม่ถูกต้อง",
		invalidYear: "ปีไม่ถูกต้อง",
		updateBirthdayFail: "อัปเดตวันเกิดไม่สำเร็จ",
		birthdayVerify: "ยืนยันการผูกวันเกิด",
		birthdayVerifyDesc: "ผูกวันเกิดของคุณเพื่อเพิ่มความปลอดภัยให้บัญชี",

		email: "อีเมลติดต่อ",
		emailDesc: "อีเมลสำหรับความปลอดภัยของบัญชี มีเพียงคุณเท่านั้นที่สามารถผูกได้",
		emailRequired: "จำเป็นต้องกรอกอีเมล",
		emailInvalid: "ที่อยู่อีเมลไม่ถูกต้อง",
		updateEmailFail: "อัปเดตอีเมลไม่สำเร็จ",
		emailVerify: "ยืนยันการผูกอีเมล",
		emailVerifyDesc: "ยืนยันอีเมลของคุณเพื่อเพิ่มความปลอดภัยให้บัญชี",

		phone: "หมายเลขโทรศัพท์",
		bindPhone: "ผูกหมายเลขโทรศัพท์",
		phoneDesc: "หมายเลขโทรศัพท์สำหรับความปลอดภัยของบัญชี มีเพียงคุณเท่านั้นที่สามารถผูกได้",
		phoneRequired: "จำเป็นต้องกรอกหมายเลขโทรศัพท์",
		phoneUsed: "กรุณาใช้หมายเลขโทรศัพท์อื่น",
		updatePhoneFail: "อัปเดตหมายเลขโทรศัพท์ไม่สำเร็จ",
		noCode: "ไม่ได้รับรหัสใช่ไหม?",
		smsHelp: "หากคุณลองหลายครั้งแล้วแต่ยังไม่ได้รับรหัสยืนยัน",
		smsTips1: "1. ตรวจสอบว่าหมายเลขโทรศัพท์มือถือที่คุณกรอกถูกต้องหรือไม่",
		smsTips2: "2. ตรวจสอบว่าหมายเลขโทรศัพท์มือถือของคุณล้าสมัยหรือไม่",
		smsTips3: "3. ตรวจสอบว่าข้อความอยู่ในกล่อง SMS หรือไม่",
		smsTips4: "4. ข้อความอาจล่าช้าไม่กี่นาที",
		phoneVerify: "ยืนยันการผูกหมายเลขโทรศัพท์",
		phoneVerifyDesc: "ยืนยันหมายเลขโทรศัพท์ของคุณเพื่อเพิ่มความปลอดภัยให้บัญชี",

		setPassword: "ตั้งรหัสผ่าน",
		passwordDesc: "ตั้งรหัสผ่านสำหรับเข้าสู่ระบบของคุณ",
		clickSelectBirthday: "คลิกเพื่อเลือกวันเกิด",
		selectBirthday: "เลือกวันเกิด",
		confirm: "ตกลง",
		cancel: "ยกเลิก",
		withdrawPassword: "รหัสผ่านการถอนเงิน",
		withdrawpasswordDesc: "ตั้งค่ารหัสผ่านสำหรับการถอนเงินของคุณ",
		set: "ตั้งค่า",
	},

	contactPhone: {
		title: "เปลี่ยนเบอร์โทรศัพท์",
		titleMobile: "เปลี่ยน",
		description: "เพิ่มเบอร์โทรศัพท์ติดต่อเพื่อการสื่อสารที่ง่ายขึ้น ข้อมูลส่วนบุคคลของคุณจะยังคงได้รับการปกป้อง",
		label: "เบอร์โทรศัพท์ติดต่อ",
		confirm: "ยืนยัน",
		submitting: "กำลังส่ง...",
		required: "กรุณากรอกเบอร์โทรศัพท์",
		invalid: "เบอร์โทรศัพท์ไม่ถูกต้อง",
		success: "อัปเดตเบอร์โทรศัพท์สำเร็จ!",
		updateFailed: "อัปเดตไม่สำเร็จ",
		tryAgain: "อัปเดตไม่สำเร็จ กรุณาลองใหม่อีกครั้งในภายหลัง",
		verifyTitleMobile: "การยืนยันโทรศัพท์",
		titleMobile: "ผูกโทรศัพท์",
		changeTitleMobile: "เปลี่ยนโทรศัพท์",
		securityTip: "โทรศัพท์เพื่อความปลอดภัยของบัญชี มีเพียงคุณเท่านั้นที่ผูกได้",
		placeholder: "หมายเลขโทรศัพท์",
		noCodeReceived: "ไม่ได้รับรหัส?",
		codeDescription: "กรอกรหัสยืนยัน 6 หลักที่ส่งไปยังข้อมูลติดต่อของคุณด้านล่าง:",
		resendIn: "ส่งอีกครั้งใน {countdown} วินาที",
		resend: "ส่งอีกครั้ง",
		submitting: "กำลังส่ง...",
		confirm: "ยืนยัน",
		invalidCode: "โปรดกรอกรหัส 6 หลักที่ถูกต้อง",
		required: "กรุณากรอกหมายเลขโทรศัพท์",
		invalid: "โปรดกรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
		success: "อัปเดตสำเร็จแล้ว",
		updateFailed: "การอัปเดตล้มเหลว",
		tryAgain: "โปรดลองอีกครั้งในภายหลัง"
	},

	contactEmail: {
		title: "เปลี่ยนอีเมล",
		titleMobile: "เปลี่ยน",
		description: "เพิ่มอีเมลติดต่อเพื่อการสื่อสารที่ง่ายขึ้น ข้อมูลส่วนบุคคลของคุณจะยังคงได้รับการปกป้อง",
		label: "อีเมลติดต่อ",
		placeholder: "อีเมล",
		confirm: "ยืนยัน",
		submitting: "กำลังส่ง...",
		required: "อีเมลไม่สามารถเว้นว่างได้",
		invalid: "กรุณากรอกอีเมลที่ถูกต้อง",
		success: "อัปเดตอีเมลสำเร็จ!",
		updateFailed: "อัปเดตไม่สำเร็จ",
		tryAgain: "อัปเดตไม่สำเร็จ กรุณาลองใหม่อีกครั้งในภายหลัง",
		verifyTitleMobile: "การยืนยันอีเมล",
		titleMobile: "ผูกอีเมล",
		changeTitleMobile: "เปลี่ยนอีเมล",
		securityTip: "อีเมลเพื่อความปลอดภัยของบัญชี มีเพียงคุณเท่านั้นที่ผูกได้",
		noCodeReceived: "ไม่ได้รับรหัส?",
		codeDescription: "กรอกรหัสยืนยัน 6 หลักที่ส่งไปยังข้อมูลติดต่อของคุณด้านล่าง:",
		resendIn: "ส่งอีกครั้งใน {countdown} วินาที",
		resend: "ส่งอีกครั้ง",
		submitting: "กำลังส่ง...",
		confirm: "ยืนยัน",
		invalidCode: "โปรดกรอกรหัส 6 หลักที่ถูกต้อง",
		required: "กรุณากรอกอีเมล",
		invalid: "โปรดกรอกที่อยู่อีเมลที่ถูกต้อง",
		success: "อัปเดตสำเร็จแล้ว",
		updateFailed: "การอัปเดตล้มเหลว",
		tryAgain: "โปรดลองอีกครั้งในภายหลัง"
	},

	accountInfo: {
		profileInfo: "ข้อมูลโปรไฟล์",
		contactInfo: "ข้อมูลการติดต่อ",
		privacy: "ความเป็นส่วนตัว",
		contactEmail: "อีเมลติดต่อ",
		contactPhone: "เบอร์โทรศัพท์ติดต่อ",
		addEmailDesc: "เพิ่มอีเมลติดต่อเพื่อการสื่อสารที่ง่ายขึ้น ข้อมูลส่วนบุคคลของคุณจะยังคงได้รับการปกป้อง",
		addPhoneDesc: "เพิ่มเบอร์โทรศัพท์ติดต่อเพื่อการสื่อสารที่ง่ายขึ้น ข้อมูลส่วนบุคคลของคุณจะยังคงได้รับการปกป้อง",
		hideUsername: "ซ่อนชื่อผู้ใช้ของฉันจากรายการสาธารณะ",
		add: "เพิ่ม",
		change: "เปลี่ยน",
		idLabel: "ID: ",
		vip: "VIP ",
		player: "ผู้เล่น",
		copied: "คัดลอกแล้ว!",
		hideSuccess: "ซ่อนชื่อผู้ใช้สำเร็จ",
		showSuccess: "แสดงชื่อผู้ใช้สำเร็จ",
		operationFailed: "การดำเนินการล้มเหลว",
		editProfile: "แก้ไขโปรไฟล์",
		contactInfo: "ข้อมูลการติดต่อ",
		contactEmail: "อีเมลติดต่อ",
		emailTip: "เพิ่มอีเมลติดต่อเพื่อการสื่อสารที่ง่ายขึ้น ข้อมูลส่วนบุคคลของคุณจะได้รับการคุ้มครอง",
		change: "เปลี่ยน",
		addEmail: "เพิ่มอีเมล",
		contactPhone: "หมายเลขโทรศัพท์ติดต่อ",
		phoneTip: "เพิ่มหมายเลขโทรศัพท์ของคุณเพื่อการตรวจสอบบัญชีที่ปลอดภัย",
		addPhone: "เพิ่มหมายเลขโทรศัพท์",
		birthdayBind: "การตรวจสอบการผูกวันเกิด",
		birthdayTip: "ผูกวันเกิดของคุณเพื่อเพิ่มความปลอดภัยให้กับบัญชีของคุณ",
		addBirthday: "เพิ่มวันเกิด",
		personalInfo: "ข้อมูลส่วนตัว",
		personalTip: "ยืนยันตัวตนของคุณเพื่อปลดล็อกบริการเพิ่มเติม ข้อมูลของคุณปลอดภัย",
		verifyNow: "ยืนยันตอนนี้",
		hideUsernameTip: "เมื่อเปิดใช้งาน ผู้ใช้อื่นจะไม่สามารถเห็นชื่อผู้ใช้ของคุณในรายการสาธารณะได้",
	},

	kyc: {
		title: "การยืนยันตัวตน",
		verifyIdentity: "ยืนยันตัวตนของคุณ",
		completeDesc: "ทำการยืนยันตัวตนให้เสร็จเพื่อรักษาความปลอดภัยของบัญชีและปลดล็อกฟีเจอร์ทั้งหมด",
		failed: "การยืนยันตัวตนล้มเหลว กรุณาลองใหม่อีกครั้ง",
		reVerify: "ยืนยันใหม่",
		checkYouOut: "มายืนยันตัวตนของคุณกัน",
		prepareDoc: "เตรียมเอกสารของคุณ",
		prepareDocDesc: "เตรียมเอกสารระบุตัวตนที่ถูกต้องให้พร้อม",
		useSmartphone: "ใช้สมาร์ทโฟน",
		useSmartphoneDesc: "คุณจะต้องใช้สมาร์ทโฟนเพื่อทำการยืนยันตัวตนให้เสร็จ",
		scanQr: "สแกนคิวอาร์โค้ด",
		scanQrDesc: "สแกนคิวอาร์โค้ดด้วยโทรศัพท์ของคุณเพื่อดำเนินการต่อบนมือถือ",
		noSmartphone: "ไม่มีสมาร์ทโฟน?",
		completeOnMobile: "ทำต่อบนมือถือ"
	},

	verify: {
		title: "การยืนยัน",
		personalVerification: "การยืนยันข้อมูลส่วนตัว",
		weak: "อ่อน",
		level1: "ระดับ 1",
		personalInfo: "ข้อมูลส่วนตัว",
		personalInfoDesc: "กรอกข้อมูลส่วนตัวของคุณให้ครบเพื่อเพิ่มความปลอดภัยให้บัญชี",
		verifyNow: "ยืนยันตอนนี้",
		level2: "ระดับ 2",
		kycVerification: "การยืนยันตัวตน KYC",
		kycDesc: "ทำการยืนยัน KYC ให้เสร็จเพื่อปลดล็อกวงเงินที่สูงขึ้นและการเข้าถึงเต็มรูปแบบ",
		docTip: "กรุณาตรวจสอบให้แน่ใจว่าเอกสารของคุณชัดเจนและถูกต้องก่อนส่ง"
	},

	personalInfo: {
		verify: "การยืนยัน",
		completeInfo: "กรอกข้อมูลของคุณให้ครบ",
		completeInfoDesc: "กรอกรายละเอียดส่วนตัวของคุณเพื่อทำการยืนยันให้เสร็จ",
		firstName: "ชื่อ",
		paternalSurname: "นามสกุลฝ่ายบิดา",
		maternalSurname: "นามสกุลฝ่ายมารดา",
		contactNumber: "เบอร์ติดต่อ",
		phoneUsed: "หมายเลขโทรศัพท์นี้ถูกใช้งานแล้ว",
		contactEmail: "อีเมลติดต่อ",
		invalidEmail: "ที่อยู่อีเมลไม่ถูกต้อง",
		detailedAddress: "ที่อยู่โดยละเอียด",
		city: "เมือง",
		street: "ถนน",
		neighborhood: "ย่าน",
		houseNumber: "บ้านเลขที่",
		postalCode: "รหัสไปรษณีย์",
		save: "บันทึก",
		male: "ชาย",
		female: "หญิง"
	},

	withdrawPassword: {
		changeTitle: "เปลี่ยนรหัสผ่านถอนเงิน",
		setTitle: "ตั้งรหัสผ่านถอนเงิน",
		changeDesc: "กรอกรหัสผ่านเดิมและตั้งรหัสผ่านถอนเงินใหม่",
		setDesc: "ตั้งรหัสผ่านถอนเงินเพื่อปกป้องเงินของคุณ",
		oldPlaceholder: "รหัสผ่านถอนเงินเดิม",
		newPlaceholder: "รหัสผ่านถอนเงินใหม่",
		confirmPlaceholder: "ยืนยันรหัสผ่านถอนเงิน"
	},

	contactBirthday: {
		title: "วันเกิดผู้ติดต่อ",
		desc: "ผูกวันเกิดผู้ติดต่อเพื่อให้สื่อสารได้ง่ายขึ้น ข้อมูลส่วนตัวของคุณจะได้รับการปกป้อง",
		label: "วันเกิดผู้ติดต่อ",
		invalid: "วันเกิดไม่ถูกต้อง"
	},

	changePassword: {
		title: "เปลี่ยนรหัสผ่าน",
		expiredDesc: "รหัสผ่านของคุณหมดอายุแล้ว กรุณาตั้งรหัสผ่านใหม่เพื่อดำเนินการต่อ",
		verifyOldDesc: "กรอกรหัสผ่านเดิมและตั้งรหัสผ่านใหม่",
		passwordPlaceholder: "รหัสผ่านเดิม",
		newPlaceholder: "รหัสผ่านใหม่",
		confirmPlaceholder: "ยืนยันรหัสผ่านใหม่",
		lengthError: "รหัสผ่านต้องมี 6 ถึง 30 ตัวอักษร",
		sameAsOld: "รหัสผ่านใหม่ต้องไม่ซ้ำกับรหัสผ่านเดิม",
		confirmRequired: "กรุณายืนยันรหัสผ่านใหม่ของคุณ",
		notMatch: "รหัสผ่านไม่ตรงกัน",
		success: "เปลี่ยนรหัสผ่านสำเร็จ",
		failed: "เปลี่ยนรหัสผ่านไม่สำเร็จ"
	},

	settingsNav: {
		title: "การตั้งค่า",
		accountInfo: "ข้อมูลบัญชี",
		security: "ความปลอดภัย"
	},

	verificationBirthday: {
		title: "วันเกิด",
		securityTip: "วันเกิดเพื่อความปลอดภัยของบัญชี มีเพียงคุณเท่านั้นที่ผูกได้",
		clickSelectBirthday: "คลิกเพื่อเลือกวันเกิด",
		invalidBirthday: "วันเกิดไม่ถูกต้อง",
		submitting: "กำลังส่ง...",
		confirm: "ยืนยัน",
		cancel: "ยกเลิก",
		selectBirthday: "เลือกวันเกิด",
		birthdayRequired: "กรุณาเลือกวันเกิด",
		updateBirthdayFail: "การอัปเดตวันเกิดล้มเหลว",
		success: "อัปเดตสำเร็จแล้ว"
	}
};